import React from 'react';
import { Grid, ListItemAvatar, ListItemText, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ImageAvatar, SquareChip, Text, useSettings, Icon } from 'app/main/components';
// import buttons from './UsersButtons';

export default function UsersVisibilityListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={props.model.user_uid}
			avatar={props.model.user_avatar}
			initials={props.model.user_title_initials}
			// labelBadge={props.model.user_label}
			// labelBadgeTooltip={props.model.user_title}
			// badgeColor={props.model.user_color}
		/>
	);

	return (
		<GridListItem avatar={avatar}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={{ xs: props.width >= 600 ? 6 : 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.user_warning_desc && (
								<Tooltip title={props.model.user_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.user_blocked_desc && (
								<Tooltip title={props.model.user_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* DISABLED */}
							{!props.model.user_enabled && (
								<Tooltip title={t('USER_DISABLED')} arrow>
									<Icon className="mr-2" icon="account-cancel" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'users', uid: props.model.user_uid }}
							>
								{props.model.user_title}
							</Text>
						</Grid>
						<Grid>
							{/* ROLES */}
							{props.model.user_duties?.map(role => (
								<SquareChip
									key={role.usda_id}
									label={role.usdt_title}
									backgroundColor={role.usdt_color}
								/>
							))}
						</Grid>
						{/* <Grid item>
									// OFFICE
									<ButtonLink
										href=""
										pack="ic"
										icon="outline-work-outline"
										fallback={t('VIEW_ITEM_NO_OFFICE')}
										>
										{props.model.user_group_title}
									</ButtonLink>
								</Grid> */}
					</Grid>
				</Grid>
				{/* {props.width >= 600 && <Grid item xs={props.width >= 600 ? 6 : 12}></Grid>} */}
			</Grid>
		</GridListItem>
	);
}
